{
  "Authentication_LoginButton": "Entrar",
  "LoginForm_LoginTitle": "Entre na sua conta",
  "LoginForm_WelcomeBack": "Bem-vindo de volta! Insira seus dados.",
  "LoginForm_Email": "Nome de usuário",
  "LoginForm_EmailRequired": "E-mail é obrigatório",
  "LoginForm_InvalidEmail": "O nome de usuário deve ser um e-mail",
  "LoginForm_EmailPlaceholder": "Insira seu e-mail",
  "LoginForm_Password": "Senha",
  "LoginForm_PasswordRequired": "Senha é necessária",
  "LoginForm_PasswordPlaceholder": "••••••••",
  "LoginForm_RememberMe": "Lembre de mim",
  "LoginForm_ForgotPassword": "Esqueceu sua senha",
  "LoginForm_SignIn": "Entrar",
  "NAME": "Authentication",
  "LoginForm_Username": "Nome de usuário",
  "LoginForm_UsernameRequired": "Nome de usuário é obrigatório",
  "LoginForm_UsernamePlaceholder": "Digite seu nome de usuário",
  "LoginForm_CME": "CME",
  "LoginForm_Or": "(Ou)",
  "LoginForm_Server": "Servidor",
  "LoginForm_ServerPlaceholder": "Selecione o servidor para fazer login",
  "LoginForm_LoginLanding_UserOnMultipleServices": "Esse nome de usuário existe em vários serviços. Forneça informações adicionais para identificá-lo.",
  "LoginForm_LoginLanding_UserNonAdmin_Error": "Ocorreu um problema ao acessar sua conta. Entre em contato com seu administrador para corrigir o problema.",
  "LoginForm_LandingPage_NextButton": "Continuar",
  "Authentication_ChangeBrowserProfile": "Alterar perfil do navegador",
  "LoginForm_LoginLanding_User_Not_Found_Error": "Não conseguimos encontrar o nome de usuário que você digitou. Verifique novamente e tente novamente."
}